import { render, staticRenderFns } from "./EmployArchive.vue?vue&type=template&id=f1be20d8&"
import script from "./EmployArchive.vue?vue&type=script&lang=js&"
export * from "./EmployArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports